import { ApplicationConfig, provideZoneChangeDetection, isDevMode, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { themeReducer } from './store/reducer/theme.reducer';
import { NGX_ECHARTS_CONFIG, NgxEchartsModule } from 'ngx-echarts';
import { authReducer } from './auth/store/auth.reducer';
import { provideHttpClient } from '@angular/common/http';
import { AuthService } from './auth/auth.service';
import { courseReducer } from './pages/courses/create-courses/store/course.reducer';
import { toastReducer } from './store/reducer/toaster.reducer';
import { ToastEffects } from './store/effects/toaster.effect';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    importProvidersFrom(NgxEchartsModule),
    { 
      provide: NGX_ECHARTS_CONFIG, 
      useValue: { echarts: () => import('echarts') } 
    },
    provideHttpClient(),
    provideStore({ 
      theme: themeReducer, 
      auth: authReducer,
      course: courseReducer,
      toasts: toastReducer
    }),
    AuthService,
    provideEffects(ToastEffects),
    provideStoreDevtools({ 
      maxAge: 25,
      logOnly: false,
      autoPause: true,
      features: {
        pause: false,
        lock: true,
        persist: true,
      }
     }),
     
]
};
